import { fmtDateTime } from "@/lib/format";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const tok = () => encodeURIComponent(localStorage.getItem("token") || "");

export const exerciseFileUrl = (eid, fid) => `${BACKEND}/api/exercises/${eid}/files/${fid}?auth=${tok()}`;
export const submissionFileUrl = (sid, fid) => `${BACKEND}/api/submissions/${sid}/files/${fid}?auth=${tok()}`;

export const SUB_STATUS = {
  consegnato:  { label: "Consegnato",  cls: "bg-sky-50 text-sky-800 border-sky-200" },
  approvato:   { label: "Approvato",   cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  da_rivedere: { label: "Da rivedere", cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

const countdown = (iso) => {
  const days = Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000);
  if (days < 0) return " · scaduto";
  if (days === 0) return " · scade oggi";
  if (days === 1) return " · scade domani";
  return days <= 14 ? ` · tra ${days} giorni` : "";
};
export const dueLabel = (d) => {
  if (!d) return "Nessuna scadenza";
  const iso = d.includes("T") ? d : `${d}T23:59`;
  return `Scadenza ${fmtDateTime(iso)}${countdown(iso)}`;
};
export const gradeLabel = (s) => (s?.grade != null ? `${s.grade}/30${s.lode ? " e lode" : ""}` : null);
